/**
 * Historico de atendimentos.
 *
 * Separado do inbox de proposito: sao duas perguntas diferentes. O inbox
 * responde "o que preciso atender agora"; o historico responde "o que
 * aconteceu com aquele cliente", e por isso a busca aqui atravessa o conteudo
 * das mensagens e o periodo, nao so a caixa do agente.
 */
export const nav = {
    permissao: 'atendimento.historico:ver',
    section: 'Atendimento',
    title: 'Historico',
    icon: 'history',
    route: '/historico',
    sequence: 3,
};

export default [
    {
        path: '/historico',
        name: 'historico',
        component: () => import('./pages/HistoricoPage.vue'),
        meta: { requiresAuth: true, permissao: 'atendimento.historico:ver' },
    },
];
